export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mbk-locked-deposites.vue?vue&type=template&id=039ad334&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/mbk/mbk-locked-deposites.vue?vue&type=template&id=039ad334&scoped=true
// module id = g7nz
// module chunks = 0